import React from "react";
// import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-slate-900 to-slate-800 text-white">
      {/* Main Footer Content */}
      {/* <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
   
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">DU Global</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted partner for seamless visa processing and global immigration solutions.
            </p>
     
            <div className="flex gap-3 pt-2">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 group"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4 text-gray-300 group-hover:text-white transition-colors" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 group"
                aria-label="Twitter"
              >
                <Twitter className="w-4 h-4 text-gray-300 group-hover:text-white transition-colors" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 group"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4 text-gray-300 group-hover:text-white transition-colors" />
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 group"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 text-gray-300 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

         
          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">About Us</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Services</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Visa Types</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Partner Program</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Support</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Help Center</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">FAQ</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Contact Us</span>
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-blue-400 text-sm transition-colors inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Documentation</span>
                </a>
              </li>
            </ul>
          </div>


          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:info@duglobal.com" className="text-gray-300 hover:text-blue-400 text-sm transition-colors">
                  info@duglobal.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+1234567890" className="text-gray-300 hover:text-blue-400 text-sm transition-colors">
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm leading-relaxed">
                  123 Business Street<br />
                  New York, NY 10001
                </span>
              </li>
            </ul>
          </div>

        </div>
      </div> */}

      {/* Bottom Bar */}
      <div className="border-t bg-white">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} DU Global. All rights reserved.
            </p>

            <div className="flex flex-wrap gap-6 items-center">
              <a
                href="/"
                className="text-sm text-gray-500 hover:text-blue-400 transition-colors"
              >
                Privacy Policy
              </a>
              <span className="text-gray-500 hidden md:inline">•</span>
              <a
                href="/"
                className="text-sm text-gray-500 hover:text-blue-400 transition-colors"
              >
                Terms of Service
              </a>
              <span className="text-gray-500 hidden md:inline">•</span>
              <a
                href="/"
                className="text-sm text-gray-500 hover:text-blue-400 transition-colors"
              >
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}